<!-- Control wrapper -->
<div 
  class="so-time-picker__control"
  [class.so-time-picker__control--horizontal]="selectDisplay() === 'horizontal'"
  [class.so-time-picker__control--form-style]="formStyle()">
  
  @if (label()) {
    <label class="so-time-picker__label select-label">{{ label() }}@if (effectiveRequired()) { <span class="required-mark">*</span>}</label>
  }

  <div class="select-container">
    <button
      type="button"
      class="time-trigger"
      [class.time-trigger--open]="isOpen()"
      [class.time-trigger--disabled]="isDisabled()"
      [disabled]="isDisabled()"
      aria-haspopup="dialog"
      [attr.aria-expanded]="isOpen()"
      (click)="onTriggerClick($event)"
      (keydown)="onTriggerKeydown($event)">
      @if (selectedText()) {
        <span class="time-trigger__value">{{ selectedText() }}</span>
      } @else {
        <span class="time-trigger__placeholder">{{ placeholder() }}</span>
      }
      <span class="material-icons time-trigger__icon">schedule</span>
    </button>
  </div>
</div>

<!-- Overlay -->
@if (isOpen()) {
  <div class="so-time-picker__overlay" cdkTrapFocus>
    <div class="so-time-picker__backdrop" (click)="onClose()"></div>
    <div 
      #overlayElement
      class="so-time-picker__panel"
      [style.top.px]="position()?.top"
      [style.left.px]="position()?.left">
      
      <!-- Time inputs in overlay -->
      <div class="so-time-picker__inputs">
        <div class="so-time-picker__input-group">
          <input
            #hoursInput
            type="text"
            class="so-time-picker__input"
            [class.so-time-picker__input--active]="clockMode() === 'hours'"
            [class.so-time-picker__input--error]="isHoursInputInvalid()"
            [attr.aria-invalid]="isHoursInputInvalid()"
            [value]="manualHours() ?? displayHours()"
            maxlength="2"
            (focus)="setClockMode('hours')"
            (change)="onHoursInputChange($event)"
            (keydown)="onTimeInputKeydown($event, 'hours')"
          />
          <span class="so-time-picker__separator">:</span>
          <input
            type="text"
            class="so-time-picker__input"
            [class.so-time-picker__input--active]="clockMode() === 'minutes'"
            [class.so-time-picker__input--error]="isMinutesInputInvalid()"
            [attr.aria-invalid]="isMinutesInputInvalid()"
            [value]="manualMinutes() ?? displayMinutes()"
            maxlength="2"
            (focus)="setClockMode('minutes')"
            (change)="onMinutesInputChange($event)"
            (keydown)="onTimeInputKeydown($event, 'minutes')"
          />
        </div>
        <div class="so-time-picker__ampm">
          <button
            type="button"
            class="so-time-picker__ampm-btn"
            [class.so-time-picker__ampm-btn--active]="selectedAmPm() === 'AM'"
            (click)="setAmPm('AM')">
            AM
          </button>
          <button
            type="button"
            class="so-time-picker__ampm-btn"
            [class.so-time-picker__ampm-btn--active]="selectedAmPm() === 'PM'"
            (click)="setAmPm('PM')">
            PM
          </button>
        </div>
      </div>

      @if (hasManualInputError()) {
        <p class="so-time-picker__error" role="alert">Ingresa una hora válida.</p>
      }

      <!-- Clock face -->
      <div class="so-time-picker__clock-container">
        <svg
          #clockFace
          class="so-time-picker__clock"
          viewBox="0 0 220 220"
          (click)="onClockClick($event)"
          (mousedown)="onClockMouseDown($event)">
          
          <circle class="so-time-picker__clock-bg" cx="110" cy="110" r="100" />
          <circle class="so-time-picker__clock-border" cx="110" cy="110" r="100" fill="none" stroke-width="1" />
          <circle class="so-time-picker__clock-center" cx="110" cy="110" r="4" />

          <line
            class="so-time-picker__clock-hand"
            x1="110" y1="110"
            [attr.x2]="110 + 70 * Math.sin(handRotation() * Math.PI / 180)"
            [attr.y2]="110 - 70 * Math.cos(handRotation() * Math.PI / 180)"
          />

          <circle
            class="so-time-picker__clock-indicator"
            [attr.cx]="110 + 85 * Math.sin(handRotation() * Math.PI / 180)"
            [attr.cy]="110 - 85 * Math.cos(handRotation() * Math.PI / 180)"
            r="18"
          />

          @if (clockMode() === 'hours') {
            @for (hour of hourNumbers(); track hour) {
              <text
                class="so-time-picker__clock-number"
                [class.so-time-picker__clock-number--selected]="isSelectedHour(hour)"
                [attr.x]="getHourPosition(hour).x"
                [attr.y]="getHourPosition(hour).y"
                text-anchor="middle"
                dominant-baseline="central"
                (click)="selectHour(hour); $event.stopPropagation()">
                {{ hour === 12 ? '00' : (hour < 10 ? '0' + hour : hour) }}
              </text>
            }
          }

          @if (clockMode() === 'minutes') {
            @for (minute of minuteNumbers(); track minute) {
              <text
                class="so-time-picker__clock-number"
                [class.so-time-picker__clock-number--selected]="isSelectedMinute(minute)"
                [attr.x]="getMinutePosition(minute).x"
                [attr.y]="getMinutePosition(minute).y"
                text-anchor="middle"
                dominant-baseline="central"
                (click)="selectMinute(minute); $event.stopPropagation()">
                {{ minute < 10 ? '0' + minute : minute }}
              </text>
            }
          }
        </svg>
      </div>

      <!-- Actions -->
      <div class="so-time-picker__actions">
        <button 
          type="button" 
          class="so-time-picker__btn so-time-picker__btn--cancel"
          (click)="onCancel()">
          Cancelar
        </button>
        <so-button-gradient-ui
          text="Aceptar"
          [disabled]="hasManualInputError()"
          (click)="onApply()">
        </so-button-gradient-ui>
      </div>
    </div>
  </div>
}
